import { render, staticRenderFns } from "./PromocionesCRUD.vue?vue&type=template&id=410fd638"
import script from "./PromocionesCRUD.vue?vue&type=script&lang=js"
export * from "./PromocionesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports